import { MagentoCart } from 'lib/types'
import { CartProduct } from 'lib/core/services/gtm/types'
import { ConfigurableProductItem, SimpleProductItem } from 'lib/core/data/quote/addProduct/types'
import { GTM } from 'lib/core/services/gtm'
import { getPriceValues } from 'lib/core/resources/helpers'
import { Ga4Events } from '../../../../../gtm/index'
import { CartItem } from '../../cart/types'

interface ConfigurableAddToCartParams {
  cart: MagentoCart
  cartItems: ConfigurableProductItem[]
  simpleProducts?: SimpleProductItem[]
}

export const triggerConfigurableAddToCart = ({
  cart,
  cartItems,
  simpleProducts
}: ConfigurableAddToCartParams) => {
  const addToCartProducts: CartProduct[] = []
  const currencyCode = cart.items[0]?.prices.price.currency

  cartItems.forEach(item => {
    const { quantity, sku } = item
    const product = cart?.items.find(element => element.variant_product?.sku === sku)?.variant_product
    const [amount] = product?.price ? getPriceValues(product?.price) : [0]

    addToCartProducts.push({
      id: sku,
      name: product?.name ?? '',
      price: amount.toString(),
      quantity
    })
  })

  simpleProducts?.forEach(item => {
    const { quantity, sku } = item
    const product = cart?.items.find(element => element.product.sku === sku)?.product
    const [amount] = product?.price ? getPriceValues(product?.price) : [0]

    addToCartProducts.push({
      id: sku,
      name: product?.name ?? '',
      price: amount.toString(),
      quantity
    })
  })

  if (addToCartProducts.length) {
    GTM.addToCart({
      currencyCode: currencyCode,
      products: addToCartProducts
    })
    Ga4Events.addToCart({
      cartItems: cart.items as unknown as CartItem[] ?? []
    })
  }
}
